<div class="subtitles-container player-audio-subtitles__container__column">
  <h1 class="player-audio-subtitles__container__column__title">
    {{ 'player.subtitles' | translate }}
  </h1>
  <div class="subtitles-vcontainer vertical-focusable-container" role="region" [attr.aria-label]="'player.subtitles' | translate">
    <div *ngFor="let track of textTrackList; index as i" tabindex="0" 
    class="player-audio-subtitles__container__column__menu-option focusable-element"
      [ngClass]="{ 'selected' : track.active }" (click)="selectTextTrack(track)"
      [attr.aria-label]="('lang.' + track.language) | translate"
      (mouseenter)="mouseEnter($event, i)" (keydown.ArrowLeft)="goToAudio()">
      {{  "lang." + track.language | translate }}
      <app-icon class="mini-check-icon" name="mini-check"></app-icon>
    </div>
    <div (click)="close()" class="exit back-btn focusable-element" tabindex="0" >{{ 'player.close' | translate }}</div>
  </div>
</div>